import ResetPasswordNew from './reset-password-new';

export default ResetPasswordNew;
